import React, { useState, useEffect } from 'react';
import {
    Card,
    CardHeader,
    CardContent,
    Divider,
    Collapse,
    TableRow,
    TableCell,
    Table, TableHead, TableBody,
} from '@material-ui/core';
import {makeStyles} from "@material-ui/styles";
import ValidatedAddressRow from "./ValidatedAddressRow";

const useStyles = makeStyles((theme) => ({
    contentSection: {
        padding: '16px 22px',
        background: '#fff',
        marginBottom: '15px',
        borderRadius: '3px',
    },
    contentSectionHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        cursor: 'pointer'
    },
    contentSectionHeaderTitle: {
        fontSize: '17px',
        fontWeight: '600',
        color: '#000',
    },
    contentSectionContent: {},
    formGroup: {
        padding: theme.spacing(2, 0)
    },
    form: {
        height: '100%',
    },
    field: {
        '& label.Mui-focused': {
            color: '#000',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: '#000',
        },
        '& .MuiOutlinedInput-root': {
            '&:hover fieldset': {
                borderColor: '#000',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#000',
            },
        },
    },
    tabActive: {
        color: '#1E69E5',
    },
    associationLink: {
        position: 'absolute',
        top: '-10px',
        right: '10px',
        cursor: 'pointer',
        decoration: 'none',
        '&:hover': {
            decoration: 'none',
        }
    },
    inheritFontWeight: {
        fontWeight: 'inherit',
    },
}));

const AddressesSection = ({ addresses,handleOnChangeInField, ...props }) => {
    const classes = useStyles()
    const [selectedAddressIndex, setSelectedAddressIndex] = useState(null);

    useEffect(() => {
        handleSelectOne(0)
    }, []);

    const handleSelectOne = (index) => {
        const updatedAddresses = addresses.map((address, i) => ({
            ...address,
            isSelected: i === index,
        }));

        handleOnChangeInField("addresses", updatedAddresses);
        setSelectedAddressIndex(index);
    };

    const headCells = [
        { id: 'check', numeric: false, disablePadding: false, label: '', sortable: false },
        { id: 'street', numeric: false, disablePadding: false, label: 'Street', sortable: false },
        { id: 'secondary', numeric: false, disablePadding: false, label: 'Secondary', sortable: false },
        { id: 'city', numeric: false, disablePadding: false, label: 'City', sortable: false },
        { id: 'state', numeric: false, disablePadding: false, label: 'State', sortable: false },
        { id: 'postal', numeric: false, disablePadding: false, label: 'Zip Code', sortable: false },
        { id: 'summary', numeric: false, disablePadding: false, label: 'Summary', sortable: false },
    ];
    return(
        <React.Fragment>
            <Card style={{marginTop: '24px'}}
            >
                <CardHeader className='cursor-pointer' title={
                    <span>Validated Addresses</span>
                }
                />
                <Divider />
                <CardContent style={{padding: 0, overflowY: 'auto'}}>
                    <div className={classes.formGroup}>
                        {addresses ? <Table className={classes.tableMarginTop}>
                            <TableHead>
                                <TableRow>
                                    {headCells.map((headCell) => (
                                        <TableCell key={headCell.id}>
                                            {headCell.label}
                                        </TableCell>
                                    ))}
                                    <TableCell/>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {addresses === undefined ?
                                    <TableRow><TableCell>Loading...</TableCell></TableRow>
                                    : addresses.map((address, index) => (
                                        <ValidatedAddressRow
                                            key={`validated-address-${index}-${address.street}-${address.secondary}`}
                                            address={address}
                                            selectedAddressIndex={selectedAddressIndex}
                                            handleSelectOne={handleSelectOne}
                                            index={index}
                                        />
                                    ))}
                            </TableBody>
                        </Table> : null}
                    </div>
                </CardContent>
            </Card>
        </React.Fragment>
    )
}

export default AddressesSection;

